import { Component } from '@angular/core';

@Component({
  selector: 'sparkles-icon',
  templateUrl: './sparkles-icon.component.html',
  styles: [':host { line-height: 0; }'],
  standalone: false
})
export class SparklesIconComponent {}
